<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="closeMessagePopup()"
></ml-status-message-popup-v2>
@if (!projectInformationRecapError() && projectInformationRecap()) {
  <div class="container">
    <div class="recap">
      <ml-recap-card-signal [recapInfo]="projectInformationRecap()" id="recap-project-information"></ml-recap-card-signal>
    </div>
    <div class="exemption">
      <ml-card-container
        [title]="'application.recap-card.card-title.redemption-value-exemption' | translate"
        [icon]="'money-transfer'"
      >
        <form novalidate (submit)="$event.preventDefault();">
          <div class="row">
            <ml-unit-signal-input
              class="unit-input"
              [id]="'redemptionValue'"
              [isLiveFormatActive]="true"
              [maxIntegerPartLength]="9"
              [decimals]="2"
              [label]="'application.exemption.redemption-value' | translate"
              [unitTranslationKey]="'application.global.symbols.euro'"
              [formField]="exemptionForm.redemptionValue"
            />
            <ml-unit-signal-input
              class="unit-input"
              [id]="'desiredRedemptionValue'"
              [isLiveFormatActive]="true"
              [maxIntegerPartLength]="9"
              [decimals]="2"
              [label]="'application.exemption.desired-redemption-value' | translate"
              [unitTranslationKey]="'application.global.symbols.euro'"
              [formField]="exemptionForm.desiredRedemptionValue"
            />
          </div>
          <ml-unit-signal-input
            [id]="'redemptionValueGap'"
            [isLiveFormatActive]="true"
            [maxIntegerPartLength]="9"
            [decimals]="2"
            [label]="'application.exemption.redemption-value-gap' | translate"
            [unitTranslationKey]="'application.global.symbols.percent'"
            [formField]="exemptionForm.redemptionValueGap"
          ></ml-unit-signal-input>
          <ml-text-area-signal-input
            [id]="'exemptionReason'"
            [label]="'application.exemption.exemption-reason' | translate"
            [maxlength]="250"
            [showCharsNumber]="true"
            [placeholder]="'application.exemption.exemption-reason-placeholder' | translate"
            [formField]="exemptionForm.exemptionReason"
            type="text"
          />
          <ml-yes-no-signal-input
            class="select"
            [formField]="exemptionForm.repurchaseAgreement"
            [id]="'exemptionField5'"
            [label]="'application.exemption.repurchase-agreement' | translate"
            [yesNoTranslations]="yesNoTranslations$ | async"
          />
          <ml-information-card [text]="'application.exemption.hint' | translate" [isYellowColored]="true" />
          <ml-loading-button
            class="button"
            [label]="'application.exemption.send' | translate"
            [priority]="'primary'"
            [size]="'medium'"
            [loading]="loadingSaveDerogation()"
            [disabled]="exemptionForm().invalid()"
            (event)="submit()"
          />
        </form>
      </ml-card-container>
    </div>
  </div>
} @else if (projectInformationRecapError()) {
  <p>message moche</p>
} @else {
  <ml-loader />
}
